import {
  AdChannel,
  InitiativeType,
  MetaObjective,
  TiktokGoal,
  OptimizationGoal,
} from "./custom-attribution-enums"

export enum ModelType {
  DIRECT_RESPONSE = "DIRECT_RESPONSE",
  BRAND_VALUE = "BRAND_VALUE",
}

export interface CreateCustomAttributionModelDto {
  adChannel: AdChannel
  initiativeType: InitiativeType
  adChannelObjective?: MetaObjective
  adChannelOptimizationGoal?: OptimizationGoal
  weights?: {
    modelType: ModelType
    source: string
    metric: string
    weight: number
  }[]
}

export interface CustomAttributionModelDto {
  id: string
  companyId: string
  adChannel: AdChannel
  initiativeType: InitiativeType
  adChannelObjective?: MetaObjective
  adChannelOptimizationGoal?: OptimizationGoal
  createdAt: Date
  updatedAt: Date
}

export interface UpsertCustomAttributionModelDto {
  adChannel: AdChannel
  initiativeType: InitiativeType
  adChannelObjective?: MetaObjective
  adChannelOptimizationGoal?: OptimizationGoal
}

export interface UpdateCustomAttributionModelDto {
  adChannel?: AdChannel
  initiativeType?: InitiativeType
  adChannelObjective?: MetaObjective | TiktokGoal
  adChannelOptimizationGoal?: OptimizationGoal
}

export interface CustomAttributionWeightDto {
  id: string
  modelId: string
  modelType: ModelType
  source: string
  metric: string
  weight: number
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date
}

export interface UpsertCustomAttributionWeightDto {
  modelId: string
  modelType: ModelType
  source: string
  metric: string
  weight: number
}

export interface BulkUpdateWeightsRequest {
  modelId: string
  weights: {
    id?: string
    modelType: ModelType
    source: string
    metric: string
    weight: number
  }[]
  deletedWeightIds: string[]
}

export type CustomAttributionControllerCreateModelApiResponse =
  /** status 200 */ CustomAttributionModelDto
export type CustomAttributionControllerCreateModelApiArg = {
  createCustomAttributionModelDto: CreateCustomAttributionModelDto
}

export type CustomAttributionControllerGetAllModelsApiResponse =
  /** status 200 */ CustomAttributionModelDto[]
export type CustomAttributionControllerGetAllModelsApiArg = void

export type CustomAttributionControllerGetModelByIdApiResponse =
  /** status 200 */ CustomAttributionModelDto
export type CustomAttributionControllerGetModelByIdApiArg = {
  id: string
}

export type CustomAttributionControllerUpdateModelApiResponse =
  /** status 200 */ CustomAttributionModelDto
export type CustomAttributionControllerUpdateModelApiArg = {
  id: string
  updateCustomAttributionModelDto: UpdateCustomAttributionModelDto
}

export type CustomAttributionControllerDeleteModelApiResponse =
  /** status 200 */ CustomAttributionModelDto
export type CustomAttributionControllerDeleteModelApiArg = {
  id: string
}

export type CustomAttributionControllerCreateWeightApiResponse =
  /** status 200 */ CustomAttributionWeightDto
export type CustomAttributionControllerCreateWeightApiArg = {
  modelId: string
  upsertCustomAttributionWeightDto: UpsertCustomAttributionWeightDto
}

export type CustomAttributionControllerGetWeightsByModelApiResponse =
  /** status 200 */ CustomAttributionWeightDto[]
export type CustomAttributionControllerGetWeightsByModelApiArg = {
  modelId: string
}

export type CustomAttributionControllerUpdateWeightApiResponse =
  /** status 200 */ CustomAttributionWeightDto
export type CustomAttributionControllerUpdateWeightApiArg = {
  modelId: string
  id: string
  upsertCustomAttributionWeightDto: UpsertCustomAttributionWeightDto
}

export type CustomAttributionControllerDeleteWeightApiResponse =
  /** status 200 */ CustomAttributionWeightDto
export type CustomAttributionControllerDeleteWeightApiArg = {
  modelId: string
  id: string
}

export type CustomAttributionControllerBulkUpdateWeightsApiResponse =
  CustomAttributionWeightDto[]

export interface CustomAttributionControllerBulkUpdateWeightsApiArg {
  modelId: string
  weights: UpsertCustomAttributionWeightDto[]
  deletedWeightIds: string[]
}
